import { Badge, CheckmarkBackgroundIcon } from '@paypalcorp/pp-react'
import React from 'react'

type PreApprovalBadgeProps = {
  children?: React.ReactNode,
  type?: 'feature' | 'success' | 'warning' | 'critical' | 'neutral',
}

const PreApprovalBadge: React.FC<PreApprovalBadgeProps> = ({ children, type = 'success' }) => {
  return (
    <Badge type={type} leftIcon={CheckmarkBackgroundIcon}>
      {children}
    </Badge>
  )
}

export default PreApprovalBadge
